const AVATAR_COLORS = [
  "#009A44", // green
  "#2563EB", // blue
  "#DC2626", // red
  "#7C3AED", // purple
  "#EA580C", // orange
  "#0891B2", // teal
];

function hashCode(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getDefaultAvatar(identifier: string | number | undefined | null): string {
  if (!identifier && identifier !== 0) return "/avatars/default-1.svg";
  const index = hashCode(String(identifier)) % AVATAR_COLORS.length;
  return `/avatars/default-${index + 1}.svg`;
}

export function getDefaultAvatarColor(identifier: string | number | undefined | null): string {
  if (!identifier && identifier !== 0) return AVATAR_COLORS[0];
  const index = hashCode(String(identifier)) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
}
